import { Licence } from "./Licence";
import { Role } from "./User";

export interface LicenceCounter {
  basic: number;
  damageAssessmentAndLeakDetection: number;
  dryingAndRepair: number;
}

export type UsedLicencesByUsers = {
  [key: string]: Licence[];
};

export type LicencesRequiredByRoles = {
  [key: string]: Licence[];
};

export interface UsedLicencesInfo {
  usedLicences: LicenceCounter;
  licencesByUsers: UsedLicencesByUsers;
}

export interface LicenceInfoV3 extends UsedLicencesInfo {
  assignedLicences: LicenceCounter;
  licencesRequiredByRoles: LicencesRequiredByRoles;
}

export function getLicencesRequieredByRoleAndTabletUsage(
  licenceInfoV3: LicenceInfoV3,
  role: Role,
  usesTablet: boolean
) {
  return (licenceInfoV3.licencesRequiredByRoles[role] ?? []).filter(
    (licence) => usesTablet || licence === Licence.BASIC_LICENCE
  );
}
